import { atom, useAtom } from "jotai";

import { type OptionChainEntry } from "#/types/options";

export const optionchainAtom = atom<OptionChainEntry[]>([]);

export const useOptionchain = () => {
  const [optionchain, setOptionchain] = useAtom(optionchainAtom);

  return {
    optionchain,
    setOptionchain,
  };
};
